import { ruPlural } from '@/lib/content/declension';

/**
 * UI-тексты статичных страниц-обёрток (page chrome):
 * страница ошибки/404, дисклеймер (юр-документ), хаб таблиц.
 * Только вертикаль/компонент-специфика; общие надзаголовки/якоря/теги — в servicePage.
 * Интерполируемые строки — функции; RU-склонения делаются через ruPlural.
 */
export const staticPagesUi = {
    en: {
        // ── Error / 404 page ──
        error: {
            kicker: 'Error · 404',
            popularLabel: 'Popular sections',
            blog: 'Blog',
            tours: 'Tours in Montenegro',
            carRental: 'Car rental in Montenegro',
            esim: 'eSIM for travel',
        },
        // ── Disclaimer (legal document) page ──
        disclaimer: {
            updated: 'Updated',
            appliesTo: 'Applies to triplinkhub.com',
            questionsHeading: 'Questions',
            questionsBefore: 'If you have questions about this document, contact us via the ',
            contactPageLink: 'contact page',
        },
        // ── Tables hub page ──
        tables: {
            sectionLabel: 'Comparison · services',
            navAriaLabel: 'Tables',
            tableWord: 'Table',
            emptyEyebrow: '00 · Tables',
            fallbackTitle: (n) => `Table ${n}`,
            rowsTag: (n) => `${n} ${n === 1 ? 'row' : 'rows'}`,
        },
    },
    ru: {
        error: {
            kicker: 'Ошибка · 404',
            popularLabel: 'Популярные разделы',
            blog: 'Блог',
            tours: 'Экскурсии в Черногории',
            carRental: 'Аренда авто в Черногории',
            esim: 'eSIM для поездки',
        },
        disclaimer: {
            updated: 'Обновлено',
            appliesTo: 'Действует для triplinkhub.com',
            questionsHeading: 'Вопросы',
            questionsBefore: 'Если у вас есть вопросы по этому документу, свяжитесь с нами через ',
            contactPageLink: 'страницу контактов',
        },
        tables: {
            sectionLabel: 'Сравнение · сервисы',
            navAriaLabel: 'Таблицы',
            tableWord: 'Таблица',
            emptyEyebrow: '00 · Таблицы',
            fallbackTitle: (n) => `Таблица ${n}`,
            rowsTag: (n) => `${n} ${ruPlural(n, ['строка', 'строки', 'строк'])}`,
        },
    },
};
